import { useData } from '@app/data/repositories';
import { ClientDetailScreen } from './ClientDetailScreen';
import { useClientDetail } from './useClientDetail';

/** Вход карточки клиента. */
export function ClientDetailRoute({
  clientId,
  onBack,
  onOpenCase,
  onOpenDocument,
}: {
  clientId: string;
  onBack: () => void;
  onOpenCase: (caseId: string) => void;
  onOpenDocument: (documentId: string) => void;
}) {
  const { db } = useData();
  const { state, actions } = useClientDetail(clientId, db);

  return (
    <ClientDetailScreen
      state={state}
      actions={actions}
      onBack={onBack}
      onOpenCase={onOpenCase}
      onOpenDocument={onOpenDocument}
    />
  );
}
